export const UID = 'UID';
export const SESSION_ID = 'SESSION_ID';
export const ERROR_STATE = 'ERROR_STATE';
export const IS_AUTH = 'IS_AUTH';
export const MENUS = 'MENUS';
export const MY_PAGES = 'MY_PAGES';
export const LOCALE = 'LOCALE';
export const PARAMS = 'PARAMS';
export const POPUP_PARAMS = 'POPUP_PARAMS';
export const REG_PARAMS = 'REG_PARAMS';
export const TOKEN = 'TOKEN';
export const CORP_CD = 'CORP_CD';
export const ROLES = 'ROLES';
export const DEPT_NO = 'DEPT_NO';
export const DEPT_LEVEL_CD = 'DEPT_LEVEL_CD';
export const LOGIN_NO = 'LOGIN_NO';
export const LOGIN_RHQ = 'LOGIN_RHQ';
export const LOGIN_SYSTEM = 'LOGIN_SYSTEM';
export const SUPER_USER_YN = 'SUPER_USER_YN';
export const SUPPORT_SNB = 'SUPPORT_SNB';
export const SUPPORT_SNB_PARAMS = 'SUPPORT_SNB_PARAMS';
export const CONN_SYSTEM = 'CONN_SYSTEM';
export const RETURN_SYSTEM = 'RETURN_SYSTEM';
export const LOGIN_ID = 'LOGIN_ID';
export const COUNTRY_CD = 'COUNTRY_CD';
export const COUNTRY_NM = 'COUNTRY_NM';
export const CORP_NO = 'CORP_NO';
export const CORP_NM = 'CORP_NM';
export const COMPANY_NO = 'COMPANY_NO';
export const JOIN_DATE = 'JOIN_DATE';
export const LAST_LOGIN = 'LAST_LOGIN';
export const LANG_CD = 'LANG_CD';
export const GUID = 'GUID';
export const EMAIL = 'EMAIL';
export const LOGIN_COUNTRY_CD = 'LOGIN_COUNTRY_CD';


// WEBPACK FOOTER //
// ./src/vuex/mutation_types.js